import { render, staticRenderFns } from "./AccountClassDetails.vue?vue&type=template&id=57a8ce18&scoped=true&"
import script from "./AccountClassDetails.vue?vue&type=script&lang=js&"
export * from "./AccountClassDetails.vue?vue&type=script&lang=js&"
import style0 from "./AccountClassDetails.vue?vue&type=style&index=0&id=57a8ce18&lang=scss&scoped=true&"


/* normalize component */
import normalizer from "!../../../../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "57a8ce18",
  null
  
)

export default component.exports